<template>
  <section>
    <Loader v-if="cargando" />
    <v-flex v-else xs12 class="card px-3 py-4">
      <nav-base
        title="Personalización del Curso"
        :showBack="true"
        :headerInfo="`${courseTitle ? `Curso: ${courseTitle}` : ' '}`"
      />
      <v-divider class="my-4" />

      <v-flex class="vflexcard">
        <form>
          <v-card flat>
            <v-toolbar-title class="mb-3">
              Información del Curso
            </v-toolbar-title>
            <div class="p-fluid p-grid p-p-3">
              <InputText
                class="p-field p-col-12 p-md-12 p-mb-4"
                id="titulo"
                type="text"
                placeholder="Título"
                v-model="curso.course_title"
              />
              <InputText
                class="p-field p-col-12 p-md-12 p-mb-4"
                id="descripcion_breve"
                type="text"
                placeholder="Descripción Breve"
                v-model="curso.course_description"
              />
              <base-input-select
                v-model="curso.representative"
                :options="adminTeachers"
                :customValue="['nombre', 'apellido']"
                :customOption="['nombre', 'apellido']"
                class="w-100"
                label="Tutor Administrativo"
                name="Profesor"
                optionLabel="id"
                placeholder="Seleccione un profesor"
                rules="required"
              />
              <div class="p-field p-col-12 p-md-12 p-py-2">
                <span>Tipo de curso</span>
                <SelectButton
                  v-model="curso.active_sence"
                  :options="options"
                  optionLabel="name"
                  optionValue="value"
                />
              </div>
              <div
                class="p-field p-col-6 p-md-6 p-py-2"
                v-if="curso.active_sence == 2"
              >
                <base-input
                  v-model="curso.course_cod_sence"
                  label="Código SENCE del curso."
                  name="Codigo Sence"
                  type="text"
                />
              </div>
              <div
                class="p-field p-col-6 p-md-6 p-py-2"
                v-if="curso.active_sence == 2"
              >
                <base-input
                  v-model="curso.course_code"
                  rules="min:7"
                  label="Identificador del curso."
                  name="Identificador del curso"
                  type="text"
                />
              </div>
              <div
                class="p-field p-col-12 p-md-12"
                v-if="curso.active_sence == 2"
              >
                <base-input
                  v-model="curso.group_code"
                  rules="min:7"
                  label="Código del grupo."
                  name="Código del grupo"
                  type="text"
                />
              </div>
              <div class="p-field p-col-6 p-md-6 p-py-2">
                <base-input
                  v-model="curso.course_start_date"
                  label="Fecha inicio curso"
                  name="Fecha inicio curso"
                  type="datetime-local"
                />
              </div>
              <div class="p-field p-col-6 p-md-6 p-py-2">
                <base-input
                  v-model="curso.course_end_date"
                  label="Fecha fin curso"
                  name="Fecha fin curso"
                  type="datetime-local"
                />
              </div>
              <v-layout
                row
                justify-space-between
                class="p-fluid p-formgrid mb-3 p-grid p-col-12 p-md-12"
              >
                <span class="p-float-label p-col-6">
                  <Dropdown
                    inputId="level_id"
                    v-model="curso.level_id"
                    :options="levels"
                    optionValue="level_id"
                    optionLabel="level_name"
                  />
                  <label class="p-pl-2" for="nivel">Nivel</label>
                </span>
                <div class="p-col-6 p-d-flex p-jc-between p-ai-center">
                  <label class="p-pr-2">Color: </label>
                  <ColorPicker
                    v-model="curso.course_color"
                    :inline="false"
                    style="flex-grow: 1"
                  />
                </div>
              </v-layout>
              <div
                class="p-col-3 p-d-flex p-jc-between p-ai-center mb-3"
                v-if="curso.active_sence == 1 && user.user_account_type == 7"
              >
                <span>Modalidad Offline</span>
                <InputSwitch v-model="curso.offline" />
              </div>
              <div class="p-field p-col-12 p-md-12">
                <InputText
                  class="p-field p-col-12 p-md-12 p-mb-4"
                  id="video_welcome"
                  type="text"
                  placeholder="Video"
                  v-model="curso.video_welcome"
                />
              </div>
              <div class="p-field p-col-12 p-md-12">
                <Textarea
                  inputId="acerca_curso"
                  v-model="curso.course_about"
                  placeholder="Acerca del Curso"
                  rows="9"
                  cols="30"
                />
              </div>
              <div class="p-field p-col-12 p-md-12">
                <Textarea
                  v-model="curso.courses_avaluation_type"
                  inputId="avaluation_type"
                  placeholder="Forma de evaluación y aprobación"
                  rows="9"
                  cols="30"
                />
              </div>
              <img
                class="p-col-12 p-md-12"
                :src="curso.gallery_image"
                :alt="curso.course_title"
                style="width: 100%"
              />
              <div class="p-field p-col-12 p-md-12">
                <label>Actualizar Imagen</label>
                <div class="p-fileupload p-fileupload-basic p-component">
                  <input
                    ref="file"
                    type="file"
                    class="custom-file-input"
                    accept="image/*"
                    v-on:change="handleFileUpload()"
                  />
                </div>
              </div>
              <div
                class="p-fileupload p-fileupload-basic p-component p-field p-col-12 p-md-12"
              >
                <label>
                  Manual del curso:
                  <a
                    v-if="curso.manual"
                    :href="curso.manual"
                    class="p-ml-2 p-mr-1"
                    target="_blank"
                  >
                    Abrir Manual
                  </a>
                </label>
                <Button
                  v-if="curso.manual"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  @click="curso.manual = null"
                />
                <input
                  v-if="curso.manual == null"
                  ref="manual"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input course-manual-file-input pt-1"
                  v-on:change="handleManualUpload()"
                />
                <input
                  v-if="curso.manual != null"
                  ref="manual"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input up-course-manual-file-input pt-1"
                  v-on:change="handleManualUpload()"
                />
              </div>

              <div
                class="p-fileupload p-fileupload-basic p-component p-field p-col-12 p-md-12"
              >
                <label>
                  Inducción:
                  <a
                    v-if="curso.induction"
                    :href="curso.induction"
                    class="pl-2"
                    target="_blank"
                  >
                    Abrir Inducción
                  </a>
                </label>
                <Button
                  v-if="curso.induction"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  @click="curso.induction = null"
                />
                <input
                  v-if="curso.induction == null"
                  ref="induction"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input course-induction-file-input pt-1"
                  v-on:change="handleInductionUpload()"
                />
                <input
                  v-else
                  ref="induction"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input up-course-induction-file-input pt-1"
                  v-on:change="handleInductionUpload()"
                />
              </div>

              <div
                class="p-fileupload p-fileupload-basic p-component p-field p-col-12 p-md-12"
              >
                <label>
                  Reglamento Interno:
                  <a
                    v-if="curso.regulation_internal"
                    :href="curso.regulation_internal"
                    class="pl-2"
                    target="_blank"
                  >
                    Abrir reglamento interno
                  </a>
                </label>
                <Button
                  v-if="curso.regulation_internal"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  @click="curso.regulation_internal = null"
                />
                <input
                  v-if="curso.regulation_internal == null"
                  ref="regulation_internal"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input course-regulation_internal-file-input pt-1"
                  v-on:change="handleRegulationInternalUpload()"
                />
                <input
                  v-else
                  ref="regulation_internal"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input up-course-regulation_internal-file-input pt-1"
                  v-on:change="handleRegulationInternalUpload()"
                />
              </div>

              <div
                class="p-fileupload p-fileupload-basic p-component p-field p-col-12 p-md-12"
              >
                <label>
                  Evaluación de Diagnóstico:
                  <a
                    v-if="curso.diagnosis_evaluations"
                    :href="curso.diagnosis_evaluations"
                    class="pl-2"
                    target="_blank"
                  >
                    Abrir Evaluación de Diagnóstico
                  </a>
                </label>
                <Button
                  v-if="curso.diagnosis_evaluations"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  @click="curso.diagnosis_evaluations = null"
                />
                <input
                  v-if="curso.diagnosis_evaluations == null"
                  ref="diagnosis_evaluations"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input course-diagnosis_evaluations-file-input pt-1"
                  v-on:change="handleDiagnosisEvaluationsUpload()"
                />
                <input
                  v-else
                  ref="diagnosis_evaluations"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input up-course-diagnosis_evaluations-file-input pt-1"
                  v-on:change="handleDiagnosisEvaluationsUpload()"
                />
              </div>
              <div
                class="p-fileupload p-fileupload-basic p-component p-field p-col-12 p-md-12"
              >
                <label>
                  Evaluación final del Curso:
                  <a
                    v-if="curso.final_evaluations"
                    :href="curso.final_evaluations"
                    class="pl-2"
                    target="_blank"
                  >
                    Abrir Evaluación de final del Curso
                  </a>
                </label>
                <Button
                  v-if="curso.final_evaluations"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  @click="curso.final_evaluations = null"
                />
                <input
                  v-if="curso.final_evaluations == null"
                  ref="final_evaluations"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input course-final_evaluations-file-input pt-1"
                  v-on:change="handleFinalEvaluationsUpload()"
                />
                <input
                  v-else
                  ref="final_evaluations"
                  type="file"
                  accept="application/pdf"
                  class="custom-file-input up-course-final_evaluations-file-input pt-1"
                  v-on:change="handleFinalEvaluationsUpload()"
                />
              </div>

              <div class="p-col-12 p-px-2">
                <Button
                  :disabled="saving"
                  label="Guardar"
                  class="p-button-success"
                  @click="saveCourse()"
                />
              </div>
              <div class="p-col-12 px-3 saving-content">
                <v-progress-circular
                  v-if="saving"
                  indeterminate
                  color="green"
                  v-bind:width="4"
                  v-bind:size="30"
                >
                </v-progress-circular>
              </div>
            </div>
          </v-card>
        </form>
      </v-flex>
      <v-divider class="my-4" />

      <v-flex class="vflexcard">
        <v-card class="py-4 p-px-2 p-px-sm-5" flat>
          <v-layout mb-3 align-start justify-space-between row>
            <v-flex xs6>
              <v-toolbar-title>Módulos</v-toolbar-title>
            </v-flex>
            <v-layout xs6 justify-end>
              <Button
                label="Agregar Módulo"
                type="primary"
                icon="pi pi-plus"
                @click="showModuloDialog()"
              />
            </v-layout>
          </v-layout>
          <DataTable
            :autoLayout="true"
            ref="dt"
            :value="modules"
            :selection.sync="selectedMódulo"
            dataKey="module_id"
            v-if="modules.length > 0"
            :rows="10"
            :filters="filters"
          >
            <template #header>
              <div class="table-header">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global'].value"
                    placeholder="Buscar..."
                  />
                </span>
              </div>
            </template>
            <Column field="module_id" header="Id" sortable></Column>
            <Column field="module_name" header="Nombre" sortable></Column>
            <Column field="teacher" header="Profesor" sortable>
              <template #body="slotProps">
                {{ slotProps.data.teacher.nombre }}
                {{ slotProps.data.teacher.apellido }}
              </template>
            </Column>
            <Column field="module_code" header="Código" sortable></Column>
            <Column header="Acciones">
              <template #body="slotProps">
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="showModuloDialog(slotProps.data, false)"
                  v-tooltip.top="'Editar'"
                />
                <Button
                  icon="pi pi-user"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="showModule(slotProps.data)"
                  v-tooltip.top="'Vista profesor'"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning p-mr-2"
                  @click="confirmDelete(slotProps.data.module_id)"
                  v-tooltip.top="'Eliminar'"
                />
              </template>
            </Column>
          </DataTable>
        </v-card>
      </v-flex>
    </v-flex>
    <!-- agregar-editar module -->
    <ModuleDialog
      :add="addModule"
      :showDialog="moduleDialog"
      :idCurso="idCurso"
      :value="mod"
      :teachers="teachers"
      @setModules="setModules"
      @close="moduleDialog = false"
    />
  </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Module from "@/models/module.model";
import moduleService from "@/services/axios/module.service";
import ModuleDialog from "@/components/Module/ModuleDialog.vue";
import {FilterMatchMode} from 'primevue/api';
export default {
  components: { ModuleDialog },
  data() {
    return {
      saving: false,
      courseTitle: null,
      file: "",
      manualFile: "",
      inductionFile: "",
      regulationInternalFile: "",
      diagnosisEvaluationsFile: "",
      finalEvaluationsFile: "",
      idCurso: 0,
      cargando: false,
      editable: false,
      addModule: true,
      moduleDialog: false,
      mod: new Module(),
      modules: [],
      teachers: [],
      adminTeachers: [],
      curso: {
        level_id: null,
        active_sence: null,
        offline: null,
        representative: null,
        course_description: null
      },
      submitted: false,
      imagenes: [],
      selectedMódulo: null,
      filters: {},
      options: [
        { name: "Normal", value: 1 },
        { name: "Sence", value: 2 }
      ]
    };
  },
  computed: {
    ...mapState(["levels", "institution", "user"])
  },
  created() {
    this.idCurso = this.$route.params.id;
    this.loadCurso();
    this.getUsersInstitution();
    this.getAdminAndTeacherFromAInstitution();
    this.initFilters();
  },
  watch: {},
  methods: {
    ...mapMutations("navigation", ["setCurrentModule", "setCurrentCourse"]),
    initFilters() {
      this.filters = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
      }
    },
    loadCurso() {
      this.$http
        .get(process.env.address.api + "institutions/courses/" + this.idCurso)
        .then(({ data }) => {
          data.offline = (data.offline === 1);
          this.curso = data;
          this.courseTitle = this.curso.course_title;
          this.modules = data.modules;
          this.cargando = false;
        });
    },
    getUsersInstitution() {
      this.$http
        .get(
          `${process.env.address.api}institutions/${this.institution.institution_id}/types/2/users`
        )
        .then(({ data }) => {
          this.teachers = data;
        });
    },
    getAdminAndTeacherFromAInstitution() {
      this.$http
        .get(
          `${process.env.address.api}institutions/${this.institution.institution_id}/admin/teacher/users`
        )
        .then(({ data }) => {
          this.adminTeachers = data;
        });
    },
    saveCourse() {
      this.saving = true;
      var formData = new FormData();
      formData.append("file", this.file);
      formData.append("course_title", this.curso.course_title);
      formData.append("video_welcome", this.curso.video_welcome);
      formData.append("course_description", this.curso.course_description);
      formData.append("representative_id", this.curso.representative == null ? null : this.curso.representative.id);
      formData.append("course_about", this.curso.course_about);
      formData.append(
        "courses_avaluation_type",
        this.curso.courses_avaluation_type
      );
      formData.append("level_id", this.curso.level_id);
      formData.append("course_start_date", this.curso.course_start_date);
      formData.append("course_end_date", this.curso.course_end_date);
      formData.append("course_cod_sence", this.curso.course_cod_sence);
      formData.append("course_color", this.curso.course_color);
      formData.append("active_sence", this.curso.active_sence);
      formData.append("offline", (this.curso.active_sence === 1) ? (this.curso.offline ? 1 : 0) : 0);
      formData.append("course_code", this.curso.course_code);
      formData.append("group_code", this.curso.group_code);
      formData.append(
        "description_evaluation_approval",
        this.curso.description_evaluation_approval
      );
      formData.append("manual", this.curso.manual);
      formData.append("induction", this.curso.induction);
      formData.append("regulation_internal", this.curso.regulation_internal);
      formData.append("diagnosis_evaluations", this.curso.diagnosis_evaluations);
      formData.append("final_evaluations", this.curso.final_evaluations);
      formData.append("manual_file", this.manualFile);
      formData.append("induction_file", this.inductionFile);
      formData.append("regulation_internal_file", this.regulationInternalFile);
      formData.append("diagnosis_evaluations_file", this.diagnosisEvaluationsFile);
      formData.append("final_evaluations_file", this.finalEvaluationsFile);
      const headers = {
        "Content-Type": "multipart/form-data"
      };
      this.$http
        .post(
          `${process.env.address.api}courses/${this.idCurso}/update`,
          formData,
          { headers }
        )
        .then(({ data }) => {
          this.saving = false;
          this.curso.gallery_image = data.gallery_image;
          this.curso.manual = data.manual;
          this.curso.induction = data.induction;
          this.curso.regulation_internal = data.regulation_internal;
          this.curso.diagnosis_evaluations = data.diagnosis_evaluations;
          this.curso.final_evaluations = data.final_evaluations;
          this.curso.offline = data.offline;
          this.setCurrentCourse(this.curso);
          this.courseTitle = this.curso.course_title;
          this.file = "";
          this.manual = "";
          this.$swal({
            text: "Curso actualizado con éxito",
            icon: "success"
          });
        })
        .catch(error => {
          this.saving = false;
          if (error.response) {
            this.$swal({
              icon: "error",
              title: `Error`,
              text: error.response.data.error
            });
          }
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    handleManualUpload() {
      this.manualFile = this.$refs.manual.files[0];
    },
    handleInductionUpload() {
      this.inductionFile = this.$refs.induction.files[0];
    },
    handleRegulationInternalUpload() {
      this.regulationInternalFile = this.$refs.regulation_internal.files[0];
    },
    handleDiagnosisEvaluationsUpload() {
      this.diagnosisEvaluationsFile = this.$refs.diagnosis_evaluations.files[0];
    },
    handleFinalEvaluationsUpload() {
      this.finalEvaluationsFile = this.$refs.final_evaluations.files[0];
    },
    onUpload(event) {
      delete event.files;
      // const event = event.files[0]
    },
    showModuloDialog(mod = new Module(), addModule = true) {
      if (this.teachers && this.teachers.length > 0) {
        this.addModule = addModule;
        this.mod = mod;
        this.moduleDialog = true;
      } else {
        this.$swal({
          text: "No se encontró ningún profesor para asignar a un nuevo módulo",
          icon: "warning"
        });
      }
    },
    setModules(modules) {
      this.modules = modules;
      this.moduleDialog = false;
    },
    confirmDelete(moduleId) {
      this.$confirm.require({
        message: "¿Estás seguro de realizar esta acción?",
        header: "Confirmación",
        icon: "pi pi-info-circle",
        acceptLabel: "Si",
        acceptClass: "p-button-danger",
        accept: () => this.deleteModule(moduleId),
        reject: () => {}
      });
    },
    deleteModule(moduleId) {
      moduleService
        .delete(moduleId)
        .then(() => {
          this.modules = this.modules.filter(
            module => module.module_id !== moduleId
          );
          this.$swal({
            text: "Módulo eliminado con éxito",
            icon: "success"
          });
        })
        .catch(error => {
          this.$swal({
            icon: "error",
            title: `Error`,
            text: error.response.data.error
          });
        });
    },
    showModule(mod) {
      this.setCurrentModule(mod);
      this.$router.push({ name: "editModule", params: { id: mod.module_id } });
    }
  }
};
</script>

<style scoped>
.saving-content {
  display: flex;
  justify-content: flex-end;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Curso/EditCurso.vue